// Deutsch: Webtexte von 'Soera's leren' (golf 7). Du-Form wie in app.de.ts. POORT:
// moedertaalreview.
export const appMemorizeDe = {
    title: 'Suren lernen',
    nav: 'Lernziele',
    card: {
        body: 'Festhalten, welche Suren eure Kinder auswendig lernen. Ein Kind trägt vor, du hörst wirklich zu und sagst „Gut gehört“. Erst dann gibt es Punkte.',
        question: 'Festhalten?',
        yes: 'Ja',
        notNow: 'Nein, jetzt nicht',
        notNowDone: 'Gut. Du kannst es hier jederzeit einschalten.',
        on: 'Eingeschaltet für {names}.',
        open: 'Zu den Lernzielen',
        settings: 'Einstellungen',
        renewal: 'Gib zuerst erneut deine Zustimmung in „Was zu unserer Familie passt“.',
    },
    wizard: {
        title: 'Suren lernen einschalten',
        step: 'Schritt {n} von 4',
        back: 'Zurück',
        next: 'Weiter',
        done: 'Einschalten',
        who: {
            title: 'Wer macht mit?',
            body: 'Schalte ein, wer mitmacht. Kinder unter 16, für die du entscheidest.',
            teen: '{name} entscheidet selbst. Das kommt später.',
            otherFaith: '{name} hat eine eigene Wahl beim Glauben und macht nicht mit.',
            none: 'In der Familie gibt es keine Kinder unter 16.',
            pick: 'Schalte mindestens ein Kind ein.',
            and: 'und',
            joins: 'Macht mit',
            paused: 'Macht gerade nicht mit. Der Fortschritt bleibt erhalten.',
            notYet: 'Macht nicht mit',
            toggle: '{name} macht mit',
            later: 'Einschalten fragt zuerst deine Zustimmung für dieses Kind. Ausschalten behält den Fortschritt.',
            more: 'Soll noch jemand mitmachen?',
            choose: 'Kinder auswählen',
            turnedOn: '{name} macht mit.',
            turnedOff: '{name} macht gerade nicht mit. Der Fortschritt bleibt erhalten.',
        },
        naming: {
            title: 'Wie nennt ihr die Suren?',
            turkish: 'Fâtiha, İhlâs, Kevser',
            arabic: 'Al-Fatiha, Al-Ichlas, Al-Kauthar',
            order: 'Reihenfolge',
            recommended: 'Empfohlen: {fatiha}, dann die kürzesten',
            prayer: 'Reihenfolge des Gebets: {fatiha}, {fil} bis {nas}',
        },
        board: {
            title: 'Auf der Tafel zeigen?',
            body: 'Alle, die vor der Tafel stehen, sehen das beim ausgewählten Kind.',
            yes: 'Ja, auf der Tafel',
            no: 'Nein, nur in der App',
        },
        known: {
            title: 'Was kann jedes Kind schon?',
            body: 'Wähle aus, was ein Kind schon auswendig kann. Dafür gibt es keine Punkte und keine Feier.',
        },
    },
    consent: {
        title: 'Zustimmung für {name}',
        text: 'Wir halten für {name} fest, welche Suren {name} lernt und kann, nur für eure Familie. Du kannst das jederzeit widerrufen; dann löschen wir den Fortschritt.',
        check: 'Ich bin Elternteil oder Vormund von {name} und stimme dem zu.',
        textMany: 'Wir halten für {name} fest, welche Suren sie lernen und können, nur für eure Familie. Du kannst das jederzeit widerrufen; dann löschen wir den Fortschritt.',
        checkMany: 'Ich bin Elternteil oder Vormund von {name} und stimme dem zu.',
        give: 'Zustimmung geben',
        withdraw: 'Zustimmung widerrufen',
        withdrawConfirm: 'Zustimmung für {name} widerrufen? Das löscht den Fortschritt von {name} sofort. Verdiente Punkte bleiben.',
        withdrawn: 'Zustimmung widerrufen. Der Fortschritt von {name} ist gelöscht.',
        given: 'Zustimmung gegeben am {date}.',
        none: 'Noch keine Zustimmung',
    },
    stage: {
        none: 'Noch nicht begonnen',
        learning: 'Am Lernen',
        ready: 'Möchte vortragen',
        known: 'Auswendig',
        review: 'Kurz auffrischen',
    },
    overview: {
        subtitle: 'Welche Suren die Kinder auswendig lernen. Jedes Kind in seinem eigenen Tempo.',
        now: 'Gerade dabei: {item}',
        nothing: 'Noch nichts begonnen',
        next: 'Als Nächstes: {item}',
        allKnown: '{name} kann die ganze Liste auswendig',
        waiting: 'Wartet aufs Zuhören ({count})',
        refresh: 'Auffrischen: {items}',
        list: 'Die Liste',
        settings: 'Einstellungen',
        open: 'Ansehen',
        paused: 'Suren lernen ist ausgeschaltet. Ausschalten löscht jetzt nichts. Nach 12 Monaten aus wird der Fortschritt gelöscht.',
        notSet: 'Suren lernen ist noch nicht eingeschaltet.',
        setUp: 'Einschalten',
        noConsent: 'Noch keine Zustimmung',
        disabled: 'Macht gerade nicht mit',
        selfDecides: 'Entscheidet selbst; kommt später',
    },
    member: {
        progress: '{x} von {y} auswendig',
        orderLearn: 'Lernreihenfolge',
        orderMushaf: 'Mushaf-Reihenfolge',
        menu: 'Was möchtest du mit {item} tun?',
        start: 'Anfangen',
        ready: 'Möchte vortragen',
        approve: 'Gut gehört',
        practice: 'Noch etwas üben',
        markKnown: 'Hat diese vorgetragen',
        baseline: 'Konnte diese schon',
        refresh: 'Kurz auffrischen',
        heard: 'Gut gehört',
        revert: 'Aus Versehen bestätigt',
        revertConfirm: 'Rückgängig machen? {item} steht danach wieder auf Am Lernen.',
        revertPoints: 'Die {count} Punkte für {item} werden wieder abgezogen.',
        negative: 'Das Guthaben von {name} wird dann negativ. Trotzdem rückgängig machen?',
        reset: 'Löschen',
        resetConfirm: '{item} für {name} löschen? Danach steht es wieder auf Noch nicht begonnen.',
        confirm: 'Ja',
        cancel: 'Nein',
        upto: 'Bis Vers',
        uptoHint: 'Bei einer längeren Sure: Bis wohin kann {name} sie schon?',
        uptoSave: 'Speichern',
        uptoClear: 'Leeren',
        uptoShort: 'bis Vers {n}',
        listen: 'Auf Quran.com anhören',
        verses: { one: '{count} Vers', other: '{count} Verse' },
        points: { one: '{count} Punkt', other: '{count} Punkte' },
        reviewRound: 'Wiederholungsrunde',
        reviewRoundBody: 'Hör ein paar bekannte Suren noch einmal an. Keine Punkte, nur kurz auffrischen.',
        reviewRoundEmpty: 'Gerade gibt es nichts aufzufrischen.',
        reviewRoundDone: 'Wiederholungsrunde fertig.',
        inactive: 'Nicht mehr in der Liste',
        extra: 'Extra',
        heardBy: 'Gehört von',
        heardParent: 'mir',
        heardTeacher: 'der Lehrkraft (Hoca, Lehrerin)',
        milestones: 'Meilensteine',
        divider: '{fatiha} und die zehn kurzen Suren',
        milestone: {
            fatiha: '{fatiha} auswendig',
            prayer_set: '{fatiha} und die zehn kurzen Suren',
            starter_set: 'Die ersten zwanzig Suren',
        },
        done: 'Gespeichert.',
        childBody: 'Tippe auf den Knopf, um anzufangen oder vorzutragen.',
        childStart: 'Damit fange ich an',
        childReady: 'Ich kann sie auswendig',
        childOops: 'Hoppla',
        childReadyDone: 'Schön. Gleich hört ein Elternteil zu.',
        agedOut: 'Ab 16 entscheidet {name} selbst. Beim Speichern wird der Fortschritt von {name} bei Suren lernen gelöscht; Punkte bleiben.',
        /** Golf 7 live r1: bevestiging vóór een geboortedatum die een meedoend kind 16+ maakt. */
        agedOutBirth: {
            title: 'Geburtsdatum speichern?',
            body: 'Mit diesem Geburtsdatum ist {name} 16 oder älter. Ab 16 entscheidet {name} selbst: Beim Speichern wird der Fortschritt von {name} bei Suren lernen gelöscht. Punkte bleiben.',
            confirm: 'Speichern und löschen',
        },
    },
    list: {
        body: 'Punkte sind für alle Kinder gleich.',
        rewardsOff: 'Belohnungen ist ausgeschaltet: Es gibt keine Punkte.',
        up: '{item} nach oben',
        down: '{item} nach unten',
        drag: 'Zum Verschieben ziehen',
        active: 'In der Liste',
        points: 'Punkte',
        presets: 'Reihenfolge mit einem Tipp',
        recommended: 'Empfohlen',
        prayer: 'Reihenfolge des Gebets',
        more: 'Mehr hinzufügen',
        moreBody: 'Extra: Thronvers (Ayat al-Kursi; ein Vers, keine Sure). Und die Suren 95 bis 78.',
        add: 'Hinzufügen',
        remove: 'Aus der Liste nehmen',
        save: 'Liste speichern',
        saved: 'Liste gespeichert.',
        keptNote: 'Bleibt gespeichert, weil es Fortschritt gibt.',
    },
    settings: {
        naming: 'Namen',
        namingTurkish: 'Türkisch: Fâtiha, İhlâs, Kevser',
        namingArabic: 'Arabisch: Al-Fatiha, Al-Ichlas, Al-Kauthar',
        riwaya: 'Lesart',
        hafs: 'Hafs',
        warsh: 'Warsch',
        warshNote: 'Bei Warsch zeigen wir keine Versnummern und keinen Link: Die Zählung unterscheidet sich je nach Druck.',
        refresh: 'Auffrischen nach',
        days: '{count} Tagen',
        never: 'Nie',
        board: 'Auf der Tafel zeigen',
        boardNote: 'Alle, die vor der Tafel stehen, sehen das beim ausgewählten Kind.',
        consent: 'Zustimmung pro Kind',
        wipe: 'Fortschritt aller löschen',
        wipeBody: 'Löscht allen Fortschritt, die Liste und die Einstellungen und widerruft die Zustimmungen. Verdiente Punkte bleiben.',
        wipeConfirm: 'Alles löschen? Das lässt sich nicht rückgängig machen.',
        wiped: 'Suren lernen wurde gelöscht.',
        off: 'Ausschalten',
        offNote: 'Ausschalten löscht jetzt nichts. Nach 12 Monaten aus wird der Fortschritt gelöscht.',
        on: 'Wieder einschalten',
        pointsNote: 'Nach dem Löschen bleiben verdiente Punkte. Schaltest du es später wieder ein, kann eine Sure erneut Punkte geben.',
        saved: 'Gespeichert.',
    },
    approvals: {
        title: 'Vortragen',
        wants: '{name} möchte {item} vortragen',
        wantsAgain: '{name} möchte {item} noch einmal vortragen',
        since: 'Seit {time}',
        points: { one: '{count} Punkt bei Gut gehört', other: '{count} Punkte bei Gut gehört' },
        approve: 'Gut gehört',
        practice: 'Noch etwas üben',
        heardBy: 'Gehört von',
        me: 'mir',
        teacher: 'der Lehrkraft (Hoca, Lehrerin)',
        already: 'Schon erledigt.',
        approved: '{item}: gut gehört.',
        practiced: 'Noch etwas üben. {name} kann es später noch einmal vortragen.',
        seen: 'Gesehen',
        milestone: '{name}: {text}',
    },
    errors: {
        stale_stage: 'Schon erledigt.',
        revert_first: 'Mache zuerst Aus Versehen bestätigt rückgängig.',
        not_eligible: 'Dieses Kind macht (noch) nicht mit.',
        consent_renewal_required: 'Gib zuerst erneut deine Zustimmung in „Was zu unserer Familie passt“.',
    },
};
//# sourceMappingURL=memorizeApp.de.js.map